import jwt from 'jsonwebtoken';
import { isModernApi } from '../../index';
import { getDocumentContent } from '../integration';
import config, {
  getModernLoginUrl,
  getLegacyLoginUrl,
  getLegacyScribonlineUrl
} from '../../config';

export const getDocumentArrayBufferExternal = (
  user,
  imageid
): Promise<string | ArrayBuffer> => {
  const token: any = jwt.decode(user.access_token);
  if (isModernApi()) {
    return getDocumentContent(user.access_token, token.client, imageid);
  }
  //decode jwt to get client
  const client = token.client;
  const url = `${getLegacyScribonlineUrl(
    client
  )}/external/pdfexport.pdf?image.superid=${imageid}`;
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    if (response.status !== 200) {
      return Promise.reject(`Returned code ${response.status}`);
    }
    var contentType = response.headers.get('content-type');
    if (contentType === 'text/html') {
      return Promise.reject('NotAuthenticated');
    }
    if (isModernApi()) {
      return response.text();
    }
    return response.arrayBuffer();
  });
};

export const getThumbnail = (user, imageid): Promise<string | ArrayBuffer> => {
  const token: any = jwt.decode(user.access_token);
  //decode jwt to get client
  const client = token.client;
  const url = isModernApi()
    ? `${config.modernApiUrl}/${client}/document/${imageid}/thumb`
    : `https://${client}/external/thumbnail.jpg?image.superid=${imageid}`;
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    if (response.status !== 200) {
      return Promise.reject(`Returned code ${response.status}`);
    }
    var contentType = response.headers.get('content-type');
    if (contentType === 'text/html') {
      return Promise.reject('NotAuthenticated');
    }
    if (isModernApi()) {
      return response.text();
    }
    return response.arrayBuffer();
  });
};

export const loadAssociatedDocuments = user => {
  const token: any = jwt.decode(user.access_token);
  //decode jwt to get client
  const client = token.client;
  const url = `https://${client}/external/docinfo`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    return response.json();
  });
};

export const loadDocument = (user, docId) => {
  const token: any = jwt.decode(user.access_token);
  //decode jwt to get client
  console.log('token', token);
  const client = token.client;
  const url = `${config.modernApiUrl}/${client}/document/${docId}`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    return response.json();
  });
};

export const getMeta = user => {
  const token: any = jwt.decode(user.access_token);
  const client = token.client;
  const url = `${config.modernApiUrl}/${client}/meta`;
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${user.access_token}`
    },
    credentials: 'same-origin'
  }).then(response => {
    return response.json();
  });
};

export const externalLogin = (username, pass) => {
  return fetch(isModernApi() ? getModernLoginUrl() : getLegacyLoginUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      username: username,
      password: pass
    })
  }).then(res => {
    return res;
  });
};
